/** File preview — bucket objects and libraries (2026-10-30). Same keys as `apercu-fichier.fr.ts`. */
export const filePreviewEn = {
  open: 'Preview {{name}}',
  loading: 'Reading the file…',
  plainText: 'Text',
  download: 'Download',
  close: 'Close',
  empty: 'The file is empty.',
  truncated: 'Preview limited to the first {{size}} of the file: download it to read it in full.',
  rowsShown: 'First {{count}} rows shown.',
  jsonInvalid: 'Not valid JSON: the content is shown as is.',
  delimiter: 'Delimiter “{{delimiter}}”',
  tab: 'tab',
  pdfFrame: 'PDF preview of {{name}}',
  unavailable: {
    title: 'Preview unavailable',
    type: 'This file type has no preview. Download it to open it.',
    binary: 'The file contains binary data: no text preview.',
    tooLarge: 'File too large to preview (over {{limit}}): nothing was downloaded. Download it to open it.',
    invalid: 'The content does not match the format its name announces: preview refused.',
  },
  formats: {
    pdf: 'PDF',
    image: 'Image',
    parquet: 'Parquet',
  },
  parquet: {
    schema: 'Schema',
    data: 'First rows',
    summary: '{{rows}} rows · {{columns}} columns · {{groups}} row group(s)',
    createdBy: 'Written by {{tool}}',
    column: 'Column',
    type: 'Type',
    nullable: 'Nullable',
    yes: 'yes',
    no: 'no',
    codec:
      'Rows not read: codec {{codecs}} is not supported by the preview (supported: SNAPPY, ZSTD and uncompressed). The schema is still exact.',
    noRows: 'No rows.',
    partialRead: 'Read by byte ranges: {{read}} of {{size}} ({{requests}} requests)',
    rowGroupTooLarge:
      'Rows not read: the first row groups weigh {{size}}, more than the preview fetches ({{limit}}). The schema is still exact; download the file for the rows.',
  },
} as const;
